import { create } from "zustand";
import { AppRecordJK, AppRecordStatusJK, RequestApi, RouteApi, StatusMsg } from "utils";
import { AppLog } from "services";
import { Service } from "utils/services";

interface NewFeedDialogShareState {
  friends: any[];
  friendAppRecord: AppRecordJK;
  initializePage: () => Promise<void>;
  disposePage: () => Promise<void>;
  fetchFriends: (isRefresh: boolean, searchText: string) => Promise<void>;
}
const useNewFeedDialogShareStore = create<NewFeedDialogShareState>((set, get) => ({
  friends: [],
  friendAppRecord: new AppRecordJK(),

  initializePage: async () => {
    try {
      useNewFeedDialogShareStore.getState().fetchFriends(true, "");
    } catch (error) {
      AppLog.show({
        message: `[initializePage]`,
        status: StatusMsg.error,
        error,
      });
    }
  },
  disposePage: async () => {
    try {
      set({
        friends: [],
        friendAppRecord: new AppRecordJK(),
      });
    } catch (error) {
      AppLog.show({
        message: `[disposePage]`,
        status: StatusMsg.error,
        error,
      });
    }
  },

  fetchFriends: async (isRefresh: boolean, searchText: string) => {
    const { friends, friendAppRecord } = get();

    let tmpFriendAppRecord = new AppRecordJK({ ...friendAppRecord });
    let tmpFriends = [...friends];

    try {
      let url = RouteApi.getFriendUser;
      url += `token=${Service.token}`;
      url += `&search_text=${searchText}`;
      url += `&user_id=${Service.userAuth.id}`;

      if (isRefresh) {
        tmpFriendAppRecord.loadingStatus = AppRecordStatusJK.loading;
        tmpFriends = [];

        set({
          friendAppRecord: tmpFriendAppRecord,
          friends: tmpFriends,
        });
      } else {
        if (tmpFriendAppRecord.canLoadMore()) {
          url = tmpFriendAppRecord.nextPageUrl!;
          tmpFriendAppRecord.loadingStatus = AppRecordStatusJK.loadingMore;
          set({ friendAppRecord: tmpFriendAppRecord });
        } else {
          return;
        }
      }

      const responses = await RequestApi(url);
      if (responses.status === "success") {
        const friendUsers = responses.friend_users;

        if (friendUsers.next_page_url) {
          tmpFriendAppRecord.loadingStatus = AppRecordStatusJK.loaded;
          tmpFriendAppRecord.nextPageUrl = friendUsers.next_page_url;
        } else {
          tmpFriendAppRecord.loadingStatus = AppRecordStatusJK.noLoadMore;
          tmpFriendAppRecord.nextPageUrl = "";
        }

        set({
          friendAppRecord: tmpFriendAppRecord,
          friends: [...tmpFriends, ...friendUsers.data],
        });
      } else {
        friendAppRecord.loadingStatus = AppRecordStatusJK.noLoadMore;
        set({ friendAppRecord: tmpFriendAppRecord });
      }
    } catch (error) {
      friendAppRecord.loadingStatus = AppRecordStatusJK.noLoadMore;
      set({ friendAppRecord: tmpFriendAppRecord });

      AppLog.show({
        message: `[fetchFriends]`,
        status: StatusMsg.error,
        error,
      });
    }
  },
}));

export default useNewFeedDialogShareStore;

